import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { Intersection } from '@splidejs/splide-extension-intersection';

export default {

	init() {
		console.log('init slider...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	// Set up all standard sliders
	bindEvents() {
		var elems = document.querySelectorAll('.splide:not([data-splide-ignore])');

		if (elems.length) {
			elems.forEach(function (elem) {
				if(elem.classList.contains('is-slider-gallery')) {
					Slider.autoScrollGallery(elem);
					return;
				}

				if(elem.classList.contains('home-hero')) {
					Slider.autoScrollHomeHero(elem);
					return;
				}

				if(elem.classList.contains('home-hero-disclosures')) {
					return;
				}

				let slider = new Splide(elem, {
					type: 'slide',
					perPage: 1,
					gap: '2.875rem',
					autoWidth: true,
					arrows: true,
					arrowPath: 'M9.70711 35.1475L8.29289 33.7333L21.5858 20.4404L8.29289 7.14754L9.70711 5.73332L24.4142 20.4404L9.70711 35.1475Z',
					pagination: false,
					trimSpace: true,
					breakpoints: {
						640: {
							gap: '1.625rem',
							arrows: false,
						}
					}
				});

                slider.mount();
			});
		}
	},

	autoScrollGallery(elem) {
		let slider = new Splide(elem, {
			type: 'loop',
			focus: 'center',
			drag: 'free',
			autoWidth: true,
			trimSpace: true,
			gap: '1rem',
			arrows: false,
			pagination: false,
			autoScroll: {
				speed: 0.5,
				autoStart: false,
				pauseOnHover: false,
				pauseOnFocus: true,
			},
			intersection: {
				inView: {
					autoScroll: true,
				},
				outView: {
					autoScroll: false,
				},
			},
		} );

		slider.mount({ AutoScroll, Intersection });
	},

	autoScrollHomeHero(elem) {
		let slider = new Splide(elem, {
			arrows: false,
			pagination: true,
			gap: 0,
			type: 'fade',
			rewind: true,
			autoplay: true,
			resetProgress: false,
			interval: 4000,
			drag: true,
			dragMinThreshold: {
				mouse: 999, // High value to disable mouse drag
				touch: 10,  // Lower value for touch drag (can't be 0)
			}	
		});

		slider.on('autoplay:playing', function (rate) {
			let percentage = rate * 100;
			$('.splide__pagination__page.custom-hero-button .progress-bar').each(function(){
				$(this).css('width', percentage + '%');
			});
		});

		$('.splide.home-hero').on('click', function(e){
			if($(e.target).closest('.splide__pagination__page').length) return;

			var autoplay = slider.Components.Autoplay;
			console.log(autoplay);
			autoplay.pause();
		});

		let disclosuresSlider = new Splide('#home-hero-disclosures-carousel', {
			arrows: false,
			pagination: false,
			gap: 0,
			type: 'fade',
			rewind: true,
			drag: false,
		});

		disclosuresSlider.sync(slider);
		slider.mount();
		disclosuresSlider.mount();

		setTimeout(Slider.customHomeHeroPagination, 50);
	},

	customHomeHeroPagination() {
		const slidesWithTitles = $('.sh-block-wrapper.home-hero-carousel .splide__slide[slide-title]');
		slidesWithTitles.each(function(){
			const slideTitle = $(this).attr('slide-title');
			const slideId = $(this).attr('id');
			const targetButton = $(this).closest('.splide:not([data-total="1"])').find('button.splide__pagination__page[aria-controls="' + slideId + '"]');

			console.log(targetButton.length)
			if(targetButton.length) {
				targetButton.html('<span class="slide-title-name"><span class="slide-title-text">' + slideTitle + '</span><span class="progress-bar"></span></span>').addClass('custom-hero-button').attr('progress-width', '0%');
			}
		});
		console.log(slidesWithTitles);

		const pagination = $('.sh-block-wrapper.home-hero-carousel .splide__pagination');
		const paginationHtml = pagination.html();
		pagination.wrap('<div class="splide__pagination-wrapper"></div>');
	}

};